<template>
    <transition name="fade">
        <div v-show="show" class="pick-player-prompt">
            <div class="confbox">
                <transition name="fade">
                    <div class="overlay-loader" v-if="showLoader">
                        <Loader color="#9d9d9d"/>
                    </div>
                </transition >

                <button @click="abort" class="topbtn back">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none"> <path d="M22 18V6C22 4.34315 20.6569 3 19 3H17C15.3431 3 14 4.34315 14 6V18C14 19.6569 15.3431 21 17 21H19C20.6569 21 22 19.6569 22 18Z" stroke="#000" stroke-width="1.5"/> <path d="M8 3H6C3.79086 3 2 4.79086 2 7V17C2 19.2091 3.79086 21 6 21H8" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M14 12H6M6 12L9 9M6 12L9 15" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                </button>

                <button @click="$parent.copyChallengeLink" class="topbtn share" v-if="!readyupmode">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none"> <path d="M14 11.9976C14 9.5059 11.683 7 8.85714 7C8.52241 7 7.41904 7.00001 7.14286 7.00001C4.30254 7.00001 2 9.23752 2 11.9976C2 14.376 3.70973 16.3664 6 16.8714C6.36756 16.9525 6.75006 16.9952 7.14286 16.9952" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M10 11.9976C10 14.4893 12.317 16.9952 15.1429 16.9952C15.4776 16.9952 16.581 16.9952 16.8571 16.9952C19.6975 16.9952 22 14.7577 22 11.9976C22 9.6192 20.2903 7.62884 18 7.12383C17.6324 7.04278 17.2499 6.99999 16.8571 6.99999" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                </button>

                <img  src="/tingn.webp"/>

                <span v-if="readyupmode && !selection"> Waiting for the party to ready up...</span>
                <span v-else-if="readyupmode && !isReady(selection)"> Press any button on your controller to ready up</span>
                <span v-else-if="readyupmode"> You're ready! Waiting on the rest of the party...</span>
                <span v-else-if="!selection"> Please select your player...</span>
                <span v-else-if="selection === 1 && !activeLobby"> You're party leader. Start game when all members have joined</span>
                <span v-else-if="!activeLobby"> Queued successfully. Wait for party leader to start game</span>
                <span v-else> This lobby is already active, attempt to join when you're ready. </span>

                <button v-ripple @click="startReadyUp" class="start" v-if="selection === 1 && !activeLobby && !readyupmode">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16px" height="16px" viewBox="0 0 24 24" fill="none"> <path d="M7 21L17 21" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M2 16.4V3.6C2 3.26863 2.26863 3 2.6 3H21.4C21.7314 3 22 3.26863 22 3.6V16.4C22 16.7314 21.7314 17 21.4 17H2.6C2.26863 17 2 16.7314 2 16.4Z" stroke="#fff" stroke-width="1.5"/> </svg>
                    Start Game
                </button>

                <button v-ripple @click="gameStarted" class="start" v-else-if="selection && activeLobby">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16px" height="16px" viewBox="0 0 24 24" fill="none"> <path d="M7 21L17 21" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M2 16.4V3.6C2 3.26863 2.26863 3 2.6 3H21.4C21.7314 3 22 3.26863 22 3.6V16.4C22 16.7314 21.7314 17 21.4 17H2.6C2.26863 17 2 16.7314 2 16.4Z" stroke="#fff" stroke-width="1.5"/> </svg>
                    Join Game
                </button>

                <div class="readyup" v-if="readyupmode">
                    <div class="slots">
                        <div
                            v-for="p in queuedPlayers"
                            :key="p.player"
                            class="slot"
                            :class="{ ready: isReady(p.player), me: selection === p.player }"
                        >
                            <div class="icon">
                                <svg v-if="isReady(p.player)" key="check" class="pad check" xmlns="http://www.w3.org/2000/svg" width="32px" height="32px" viewBox="0 0 24 24" fill="none">
                                    <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.5"/>
                                    <path d="M7.5 12.5L10.5 15.5L16.5 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                <svg v-else key="pad" class="pad" xmlns="http://www.w3.org/2000/svg" width="32px" height="32px" viewBox="0 0 24 24" fill="none">
                                    <path d="M6 8H18C20.2091 8 22 9.79086 22 12V14.5C22 16.433 20.433 18 18.5 18C17.6 18 16.75 17.6 16.2 16.9L14.8 15H9.2L7.8 16.9C7.25 17.6 6.4 18 5.5 18C3.567 18 2 16.433 2 14.5V12C2 9.79086 3.79086 8 6 8Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
                                    <path d="M7 10.5V13.5M5.5 12H8.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                                    <circle cx="16" cy="11" r="0.9" fill="currentColor"/>
                                    <circle cx="18" cy="13" r="0.9" fill="currentColor"/>
                                </svg>
                            </div>
                            <div class="name">P{{ p.player }}</div>
                            <div class="leds"><i v-for="led in 4" :key="led" :class="{ on: led === p.player }"></i></div>
                            <div class="status">{{ statusText(p.player) }}</div>
                        </div>
                    </div>
                </div>

                <div class="actions" v-if="!readyupmode">
                    <button
                        v-for="n in 4"
                        :key="n"
                        @click="select(n)"
                        :disabled="isTakenByOther(n)"
                        :class="{selected: selection === n, taken: isTakenByOther(n)}"
                    >P{{ n }}</button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import io from 'socket.io-client'

const Loader = () => import('@/components/Loader')

export default {
    name: 'pickPlayer',
    components: {
        Loader,
    },

    props: {
        show: Boolean,
        playerSelected: Function,
        gameStarted: Function,
    },

    beforeUnmount: function(){
        this.teardown()
    },

    beforeDestroy: function(){
        this.teardown()
    },

    watch: {
        show(val) {
            if (!val) this.stopGamepadListener()
        }
    },

    async mounted() {
        if (!this.socket) { this.socket = io(process.env.VUE_APP_SERVER + '/') }

        this.socket.on('partyPlayersChanged', (players) => { this.players = players })

        this.socket.on('playerReady', (players) => {
            this.readyPlayers = players
            //if party leader
            if(this.selection === 1 && !this.activeLobby){
                //if all players ready (startTriggered stops a duplicate event from starting twice)
                if(this.readyupmode && this.allPlayersReady && !this.startTriggered){
                    this.startTriggered = true
                    this.start()
                }
            }
        })

        this.socket.on('partyGameStarted', () => {
            this.stopGamepadListener()
            setTimeout(() => { this.gameStarted() }, 1000)
        })

        this.socket.on('partyReadyUp', () => { this.beginReadyUpFlow() })

        this.socket.on('webStreamReloaded', () => {
            this.$parent.ready = false
            this.$parent.$nextTick(() => {
                setTimeout(() => {
                    this.$parent.ready = true
                }, 1000)
            })
        })

        this.socket.on('endGameLobby', async () => {
            this.activeLobby = true
            this.abort()
        })

        this.userId = window.localStorage.getItem('cid')

        const activeLobby = await window.afetch('/gameParty')
        const alData = await activeLobby.json()
        this.players = alData.players
        this.activeLobby = alData.started
        this.othersAlreadyReady = alData.readying
        this.readyPlayers = alData.readyPlayers
    },
    data() {
        return {
            showLoader: false,
            readyupmode: false,
            othersAlreadyReady: false,
            socket: null,
            userId: '',
            selection: null,
            players: [],   // [{ player, user }]
            readyPlayers: [],   // [{ player, user }]
            pending: false,
            activeLobby: false,
            hasReadied: false,      // this client has sent its ready call (only ever send one)
            startTriggered: false,  // party leader already called start()
            gamepadRaf: null,       // requestAnimationFrame handle for the gamepad poll
            isUnmounted: false,     // permanent kill switch - the gamepad can never listen again once set
        }
    },

    computed: {
        takenNumbers() {
            return this.players.map(p => p.player)
        },

        // queued players in P1-P4 order (only these get a slot in the ready up UI)
        queuedPlayers() {
            return [...this.players].sort((a, b) => a.player - b.player)
        },

        // every queued player has been confirmed ready by the server
        allPlayersReady() {
            return this.players.length > 0 &&
                this.players.every(p => this.readyPlayers.some(r => r.player === p.player))
        },
    },

    methods: {
        beginReadyUpFlow(){
            this.$parent.ready = true
            this.showLoader = true
            //give time for shit to connect

            setTimeout(() => {
                this.showLoader = false
                this.readyupmode = true
                // fresh round
                this.readyPlayers = []
                this.hasReadied = false
                this.startTriggered = false

                // only queued players need to ready up, everyone else just watches the slots
                if (this.selection) this.startGamepadListener()
            }, 2000)
            // could be shorter i think
        },

        // ---- ready up: controller listening ----

        anyButtonPressed() {
            const pads = navigator.getGamepads ? navigator.getGamepads() : []
            for (const pad of pads) {
                if (pad && pad.connected && pad.buttons.some(b => b.pressed)) return true
            }
            return false
        },

        startGamepadListener() {
            this.stopGamepadListener()
            if (this.hasReadied || this.isUnmounted) return // already sent / component gone - never listen

            // a button already held when ready up starts (eg. they hit Start on the
            // controller) doesn't count - it has to be released and pressed again
            let wasPressed = this.anyButtonPressed()

            const poll = () => {
                if (this.hasReadied || this.isUnmounted) return
                const pressed = this.anyButtonPressed()
                if (pressed && !wasPressed) {
                    this.onControllerPress()
                    return // never reschedule
                }
                wasPressed = pressed
                this.gamepadRaf = requestAnimationFrame(poll)
            }
            this.gamepadRaf = requestAnimationFrame(poll)
        },

        stopGamepadListener() {
            if (this.gamepadRaf !== null) {
                cancelAnimationFrame(this.gamepadRaf)
                this.gamepadRaf = null
            }
        },

        teardown() {
            this.isUnmounted = true
            this.stopGamepadListener()
            if (this.socket) {
                this.socket.disconnect()
                this.socket = null
            }
        },

        async onControllerPress() {
            if (this.hasReadied) return
            this.hasReadied = true
            this.stopGamepadListener()

            try {
                await this.callApi('/party/playerReady', this.selection)
            } catch (err) {
                console.error('ready up call failed', err)
            }
        },

        // server-confirmed, or this player's own press (so their slot flips instantly)
        isReady(n) {
            if (!n) return false
            return this.readyPlayers.some(p => p.player === n) || (n === this.selection && this.hasReadied)
        },

        statusText(n) {
            if (this.isReady(n)) return 'Ready'
            return n === this.selection ? 'Press a button' : 'Waiting'
        },

        isTakenByOther(n) {
            return this.selection !== n && this.takenNumbers.includes(n)
        },

        async select(n) {
            if (this.pending || this.isTakenByOther(n)) return
            this.pending = true

            try {
                if (n === this.selection) {
                    await this.callApi('/party/removePlayer', n)
                    this.selection = null
                    this.playerSelected(null)
                } else {
                    await this.callApi('/party/addPlayer', n)
                    this.selection = n
                    this.playerSelected(n)
                    if(this.othersAlreadyReady && !this.activeLobby){
                        //mannually trigger ready up
                        this.beginReadyUpFlow()
                    }
                }
            } catch (err) {
                // most likely someone else grabbed the slot first - the
                // socket update will correct the UI shortly
                console.error(err)
            } finally {
                this.pending = false
            }
        },

        async callApi(path, player) {
            const res = await window.afetch(path, {
                method: 'POST',
                body: JSON.stringify({
                    player,
                    user: this.userId
                }),
            })

            return res.json()
        },

        async startReadyUp(){
            await window.afetch('/party/readyup')
        },

        async start(){
            await window.afetch('/party/startGame')
        },

        async abort(){
            this.stopGamepadListener()
            if(!this.activeLobby){
                await window.afetch('/stopGameStream')
            }else{
                //free selection before leaving
                await this.select(this.selection)
            }
            await this.$parent.resetTheater()
            this.$router.push('/games')
        },

    }
  }
</script>

<style scoped lang="scss">
.pick-player-prompt {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.9);
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    z-index: 999999;

    .overlay-loader{
        position: absolute;
        width: 100%;
        height: 100%;
        border-radius: 16px;
        background-color: white;
        z-index: 999;
    }

    .confbox{
        position: relative;
        height: auto;
        width: 450px;
        background-color: white;
        z-index: 999;
        overflow: hidden;
        border-radius: 16px;

        .topbtn{
            position: absolute;
            width: 42px;
            height: 42px;
            padding: 10px;
            border: none;
            border-radius: 12px;
            background-color: transparent;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            z-index: 9;
            top: 12px;
            &.share{
                right: 12px;
            }
            &.back{
                left: 12px;
            }

            &:hover{
                background-color: rgba(0, 0, 0, 0.1);
            }
        }

        img{
            width: 175px;
            display: block;
            padding: 50px 0;
            padding-bottom: 25px;
            margin: 0 auto;
        }

        span{
            color: black;
            width: 85%;
            font-size: 11px;
            display: block;
            margin: 0 auto;
            padding: 20px 0;
            padding-top: 0;
            text-align: center;
        }
        .start{
            padding: 10px 0;
            cursor: pointer;
            width: 90%;
            margin: 0 auto;
            margin-bottom: 20px;
            border: 1px solid white;
            border-radius: 5px;
            background-color: transparent;
            color: white;
            display: flex;
            align-items: center;
            justify-content: center;
            border-color: #00b894;
            background-color: rgba(#00b894, 0.75);
            transition-duration: 0.3s;
            &:hover{
                background-color: #00b894;
            }

            svg{ padding-right: 5px; }
        }

        .actions{
            display: flex;
            flex-direction: row;
            button{
                width: 25%;
                font-weight: bold;
                border: 1px solid white;
                background-color: rgba(0, 0, 0, 0.08);
                padding: 20px;
                transition-duration: 0.3s;
                cursor: pointer;

                &.taken{
                    background: #797979;
                    color: black;
                    transition-duration: 0.3s;
                    opacity: 0.3;
                    pointer-events: none;
                    cursor: default;
                }
                &.selected{
                    transition-duration: 0.3s;
                    color: rgba(46, 204, 113,0.8)!important;
                    background-color: rgba(#797979, 0.3)!important;
                }
                &:hover{
                    background-color: rgba(0, 0, 0, 0.1);
                }
            }
        }

        // NB: divs / <i> only in here - `.confbox span` above would restyle any span.
        // Text colours are set explicitly so nothing inherits white from the page.
        .readyup{
            padding: 0 20px 24px;
            color: #000;

            .slots{
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: stretch;
                gap: 10px;
            }

            .slot{
                flex: 0 1 92px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: flex-start;
                padding: 14px 4px 12px;
                border: 1.5px solid #e2e2e2;
                border-radius: 12px;
                background-color: #fafafa;
                color: #000;
                text-align: center;
                transition: border-color 0.3s, background-color 0.3s;

                .icon{
                    height: 32px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .pad{ color: #000; }

                .name{
                    margin-top: 6px;
                    font-weight: bold;
                    font-size: 15px;
                    line-height: 18px;
                    color: #000;
                }

                // Wii remote style player lights - the square matching the player number is lit
                .leds{
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    gap: 4px;
                    margin-top: 8px;

                    i{
                        width: 8px;
                        height: 8px;
                        border-radius: 1px;
                        background-color: #d6d6d6;
                        &.on{
                            background-color: #2f8cff;
                            box-shadow: 0 0 6px rgba(#2f8cff, 0.8);
                        }
                    }
                }

                .status{
                    margin-top: 8px;
                    min-height: 28px; // keeps the row height even when "Press a button" wraps
                    font-size: 12px;
                    line-height: 14px;
                    color: #000;
                }

                // queued, hasn't pressed yet - light blinks like a Wii remote looking for a connection
                &.me{
                    border-color: #9d9d9d;
                    background-color: #fff;
                }
                &:not(.ready) .leds i.on{
                    animation: led-blink 1s steps(1, end) infinite;
                }

                // pressed - light goes solid, gamepad becomes a green circle check
                &.ready{
                    border-color: #00b894;
                    background-color: rgba(#00b894, 0.08);
                    .pad.check{
                        color: #00b894;
                        animation: pad-pop 0.35s ease-out;
                    }
                }
            }

        }
    }
}

@keyframes led-blink {
    0%   { opacity: 1; }
    50%  { opacity: 0.15; }
}

@keyframes pad-pop {
    0%   { transform: scale(1); }
    40%  { transform: scale(1.25); }
    100% { transform: scale(1); }
}

@media (prefers-reduced-motion: reduce) {
    .pick-player-prompt .confbox .readyup .slot {
        &:not(.ready) .leds i.on { animation: none; opacity: 0.6; }
        &.ready .pad.check { animation: none; }
    }
}
</style>
